<template>
  <div class="page-content">
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">添加公告</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div  notice_form-submit-page">
        <el-form :inline="false" :model="formInline" ref="formInline" :rules="rules" class="box-content-form" label-width="100px">
          <el-form-item label="公告名称:" prop="title">
            <el-input v-model="formInline.title" :maxlength=20 placeholder="请输入公告名称" style="width:420px"></el-input>
          </el-form-item>
          <el-form-item class="notice-edit" label="公告范围:" prop="officeName">
            <el-select v-model="interestFitValue" multiple placeholder="请选择权公告范围" style="width:420px;min-height:36px!important;">
              <el-option
                v-for="item in interestFitOptions"
                :key="item.id"
                :label="item.level_title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间:" prop="start">
           <el-date-picker
              v-model="formInline.start"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" prop="end">
             <el-date-picker
              v-model="formInline.end"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="链接:" prop="url">
              <el-input v-model="formInline.url"></el-input>
          </el-form-item>
          <el-form-item label="公告首图:" prop="picture">
            <div style="text-align:left;">
              <el-upload
                class="acivity-uploader"
                name="file_upload"
                :action="uploadURL"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <div v-if="formInline.picture"  class="opacity-div">
                  <img :src="formInline.picture" class="notice-pic">
                  <div class="back-div">点击更换</div>
                </div>
                <div slot="tip" style="line-height:20px;color:#606266;">必填！建议尺寸750*360</div>
                <img v-if="formInline.picture === ''" src="../../assets/images/Group.png" class="default-images">
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="内容:" class="picture-text-item" prop="content">
            <el-upload class="pic-uploader" action="" :show-file-list="false"></el-upload>
            <editor v-model="formInline.content" class="picture-text-details" :action="uploadURL"></editor>
          </el-form-item>
          <el-form-item>
            <el-button class="second-page-btn" style="margin:78px 78px 0 0;float:left" type="primary" @click="submitForm('formInline')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>
import { API_HOST } from '@/api/local'
import { addNotice, getMemberLevelList } from '@/api/customer.js'
import editor from '@/components/common/editor'
export default {
  name: 'importData',
  data () {
    return {
      interestFitValue: [],
      interestFitOptions: [],
      content: '<p></p>',
      formInline: {
        picture: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入公告名称', trigger: 'blur' }
        ],
        start: [
          { required: true, message: '请输入开始时间', trigger: 'blur' }
        ],
        end: [
          { required: true, message: '请输入结束时间', trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '请输入公告首图', trigger: 'blur' }
        ]
      },
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      dialogVisible: false,
      input: '',
      signName: '',
      options: []
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addNoticeAction()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.picture = res.data.path
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传,请耐心等待!')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M)
    },
    addNoticeAction() {
      // let userInfo = Lockr.get('userInfo')
      // //发布人ID
      // this.formInline.issuer_id = userInfo.id
      this.formInline.body = this.formInline.content
      this.formInline.grade_list = this.interestFitValue.toString()
      addNotice(this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/notice-list')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    loadMemberLevelList() {
      getMemberLevelList().then(res => {
        this.interestFitOptions = res.data.data.list
      })
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.loadMemberLevelList()
  },
  mounted() {
  },
  components: {
    editor
  }
}
</script>

<style scoped>

.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 750px !important;
  padding-left: 20%;
  box-sizing: border-box;
}
.box-content-form {
  margin-top: 30px;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 300px;
}
.acivity-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.acivity-uploader .el-upload:hover {
    border-color: #409EFF;
}
.acivity-uploader-icon {
    border: 1px dashed #d9d9d9;
    font-size: 28px;
    color: #8c939d;
    width: 208px;
    height: 208px;
    line-height: 208px;
    text-align: center;
}
.default-acivity {
    width: 108px;
    display: block;
}
.avatar {
    width: 208px;
    height:auto!important;
    display: block;
}
.pic-uploader {
    display: none;
}
.notice-pic {
    width: 420px;
    height: 202px;
    display: block;
    position: relative;
}
.opacity-div {
  width: 420px;
  height: 202px;
}
.opacity-div:hover .back-div {
  opacity: 1;
}
.back-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 420px;
  height: 202px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  color: #fff;
  line-height: 202px;
}
.default-images {
  width: 120px;
}
.interest-uploader {
  width: 120px;
  height: 120px;
}
</style>
